export default function Marquee() {
  const items = [
    "Tree Removal",
    "Trimming",
    "Stump Grinding",
    "Landscaping",
    "Pool Builds",
    "Irrigation",
    "Yard Cleanup",
    "Patios",
    "Storm Response",
  ];
  const full = [...items, ...items];
  return (
    <section
      data-testid="marquee-section"
      className="bg-[#FF5A00] text-[#0B1810] py-5 border-y-4 border-[#0B1810] overflow-hidden"
    >
      <div className="marquee-track whitespace-nowrap">
        {full.map((t, i) => (
          <span
            key={i}
            className="font-heading text-3xl md:text-4xl tracking-wider flex items-center gap-12"
          >
            {t}
            <span className="inline-block w-2 h-2 bg-[#0B1810] rotate-45" />
          </span>
        ))}
      </div>
    </section>
  );
}
